(function() {
'use strict';

angular.module('TR')
    .directive('scrollPage', scrollPage);

function scrollPage() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            toBottom: '='
        },
        template: '<a ng-click="scrollPage()" ng-class="{visible : visible }" class="scroll-page" href="#"></a>',
        link(scope) {
            let scrollTo = 0;
            const offset = 400;
            const maxDuration = 500;
            const win = $(window);
            const toBottom = scope.toBottom;

            scope.visible = false;

            scope.checkVisibility = function() {
                scrollTo = win.scrollTop() + (toBottom ? win.height() : 0);
                if ((toBottom && scope.visible !== (scrollTo <= $(document).height() - offset))
                    || !toBottom && scope.visible !== (scrollTo >= offset)) {
                    scope.$apply(scope.visible = !scope.visible);
                }
            };

            win.on(toBottom ? 'scroll.scrollBottom' : 'scroll.scrollTop', _.debounce(scope.checkVisibility, 100));

            scope.scrollPage = function() {
                // set a duration relative to the distance we need to scroll
                const duration = Math.min(maxDuration, Math.abs(Math.round(scrollTo * 0.3)));
                let scrollInfo = { scrollTop: toBottom ? $(document).height() : 0 };
                $('html, body').stop().animate(scrollInfo, { easing: 'swing', duration });
            };

            scope.$on('$destroy', function() {
                win.off(toBottom ? 'scroll.scrollBottom' : 'scroll.scrollTop');
            });
        }
    };
}
})();
